import { render, staticRenderFns } from "./TransactionHistoryPage.vue?vue&type=template&id=1bace0d8&scoped=true"
import script from "./TransactionHistoryPage.vue?vue&type=script&lang=js"
export * from "./TransactionHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./TransactionHistoryPage.vue?vue&type=style&index=0&id=1bace0d8&prod&scoped=true&lang=css"
import style1 from "./TransactionHistoryPage.vue?vue&type=style&index=1&id=1bace0d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bace0d8",
  null
  
)

export default component.exports